import { render, staticRenderFns } from "./TheCopyright.vue?vue&type=template&id=f6f64306"
import script from "./TheCopyright.vue?vue&type=script&lang=js"
export * from "./TheCopyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports